{
  "common": {
    "memberCenter": "Espace membre",
    "points": "Points",
    "level": "Niveau",
    "coupons": "Coupons",
    "checkin": "Connexion quotidienne",
    "history": "Historique",
    "balance": "Solde",
    "expire": "Expirer",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "loading": "Chargement...",
    "noData": "Aucune donnée",
    "retry": "Réessayer",
    "success": "Succès",
    "failed": "Échec"
  },
  "points": {
    "earn": "{amount} points gagnés",
    "spend": "{amount} points dépensés",
    "balance": "Solde actuel : {amount} points",
    "expired": "{amount} points expirés",
    "estimated": "Estimation (en attente de confirmation)"
  },
  "level": {
    "current": "Niveau actuel : {name}",
    "nextLevel": "Niveau suivant : {name}",
    "progress": "{current}/{target} pour le niveau suivant",
    "upgraded": "Félicitations ! Niveau {name} atteint"
  },
  "coupon": {
    "claim": "Récupérer",
    "claimed": "Récupéré",
    "expired": "Expiré",
    "used": "Utilisé",
    "validUntil": "Valable jusqu'au {date}"
  },
  "checkin": {
    "today": "Connexion du jour",
    "done": "Déjà connecté",
    "streak": "{days} jours consécutifs",
    "reward": "+{amount} points"
  },
  "errors": {
    "network": "Erreur réseau, veuillez réessayer",
    "unauthorized": "Veuillez vous connecter",
    "serverError": "Erreur serveur, veuillez réessayer plus tard",
    "timeout": "Délai d'attente dépassé"
  },
  "ui": {
    "memberCenter": {
      "loading": "Chargement...",
      "avatarAlt": "Avatar du membre",
      "pointsBalance": "Mes points",
      "menuLabel": "Navigation membre",
      "menu": {
        "pointsDetail": "Historique des points",
        "levelDetail": "Avantages du niveau",
        "coupons": "Mes coupons",
        "referral": "Inviter des amis",
        "checkin": "Connexion quotidienne"
      }
    },
    "pointsDetail": {
      "title": "Historique des points",
      "empty": "Aucun historique de points",
      "loading": "Chargement...",
      "noMore": "Plus aucun enregistrement",
      "listLabel": "Transactions de points",
      "status": {
        "pending": "En attente",
        "active": "Actif",
        "used": "Utilisé",
        "expired": "Expiré"
      }
    },
    "levelProgress": {
      "loading": "Chargement...",
      "maxLevel": "Niveau maximum atteint",
      "progressLabel": "Progression du niveau",
      "noBenefits": "Aucun avantage",
      "nextLevel": "Niveau suivant : {name}",
      "benefitsTitle": "Mes avantages"
    },
    "couponList": {
      "title": "Mes coupons",
      "tabsLabel": "Catégories de coupons",
      "listLabel": "Liste des coupons",
      "empty": "Aucun coupon disponible",
      "freeShipping": "Livraison gratuite",
      "giftValue": "Cadeau",
      "discountValue": "{value}% de réduction",
      "type": {
        "discount": "Réduction",
        "cash": "Espèces",
        "shipping": "Livraison",
        "gift": "Cadeau"
      },
      "tab": {
        "available": "Disponible",
        "used": "Utilisé",
        "expired": "Expiré"
      }
    },
    "referralShare": {
      "loading": "Chargement...",
      "title": "Inviter des amis",
      "shareTitle": "Invitez vos amis et gagnez des points",
      "shareText": "Inscrivez-vous et recevez un cadeau !",
      "invitedCount": "Invités",
      "rewardPoints": "Points gagnés",
      "codeLabel": "Mon code de parrainage",
      "linkLabel": "Lien de parrainage",
      "copy": "Copier",
      "copyCode": "Copier le code de parrainage",
      "share": "Partager",
      "rewardHint": "Gagnez {points} points par ami invité"
    },
    "checkinCalendar": {
      "loading": "Chargement...",
      "checking": "Connexion en cours...",
      "checkin": "Se connecter",
      "alreadyChecked": "Déjà connecté",
      "day": "{count} jours",
      "title": "Connexion quotidienne",
      "streak": "{days} jours consécutifs",
      "calendarLabel": "Calendrier de connexion",
      "rewardsTitle": "Récompenses de série",
      "rewardsLabel": "Liste des récompenses",
      "weekday": {
        "sun": "Dim",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Jeu",
        "fri": "Ven",
        "sat": "Sam"
      }
    },
    "auth": {
      "login": {
        "emailLabel": "E-mail",
        "passwordLabel": "Mot de passe",
        "submit": "Se connecter",
        "createAccount": "Créer un compte",
        "forgotPassword": "Mot de passe oublié ?",
        "orDivider": "ou"
      },
      "register": {
        "emailLabel": "E-mail",
        "passwordLabel": "Mot de passe",
        "confirmPasswordLabel": "Confirmer le mot de passe",
        "passwordHint": "Au moins 8 caractères, avec des lettres et des chiffres",
        "submit": "Créer un compte",
        "hasAccount": "Vous avez déjà un compte ? Se connecter",
        "passwordMismatch": "Les mots de passe ne correspondent pas"
      },
      "oauth": {
        "continueWith": "Continuer avec {provider}"
      },
      "verify": {
        "resend": "Renvoyer le code",
        "resendCountdown": "Renvoyer ({countdown}s)"
      },
      "forgot": {
        "title": "Réinitialiser le mot de passe",
        "description": "Entrez votre e-mail et nous vous enverrons un code de vérification.",
        "emailLabel": "E-mail",
        "submit": "Envoyer le code",
        "backToLogin": "Retour à la connexion"
      }
    }
  },
  "sdk": {
    "error": {
      "211001": "Échec de vérification de la signature webhook",
      "211003": "Requête webhook en double",
      "211005": "Identifiants de plateforme expirés",
      "211900": "Opération échouée, veuillez réessayer",
      "211903": "Paramètres de requête invalides",
      "211909": "Veuillez vous connecter ou rafraîchir votre session",
      "211910": "Accès refusé",
      "211911": "Membre introuvable",
      "211912": "Conflit d'identité, veuillez contacter le support",
      "211931": "Erreur de configuration du niveau",
      "211933": "Avantage du niveau indisponible",
      "211951": "Solde de points insuffisant",
      "211952": "Erreur du grand livre des points, contactez le support",
      "211955": "Règle de gain de points non configurée",
      "211956": "Échec de la déduction des points",
      "211957": "Points expirés",
      "211958": "Conflit de transaction de points, veuillez réessayer",
      "211971": "Coupon indisponible",
      "211973": "Coupon déjà récupéré",
      "211975": "Coupon expiré",
      "211976": "Coupon déjà utilisé",
      "211991": "Service occupé, veuillez réessayer plus tard",
      "network": "Erreur réseau, vérifiez votre connexion",
      "timeout": "Délai d'attente dépassé, veuillez réessayer",
      "aborted": "Requête annulée",
      "parse": "Erreur d'analyse de la réponse",
      "unauthorized": "Veuillez vous connecter",
      "config": "Erreur d'initialisation du SDK",
      "unknown": "Une erreur inconnue est survenue"
    }
  }
}
